import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";

import "./Projects.css";
import { PROJECTS, ROUTES, SECTIONS } from "../../data";
import ProjectCard from "../project-card/ProjectCard";

export default function Projects() {
  const navigate = useNavigate();

  const handleOnViewAllProjects = () => {
    navigate(ROUTES.ALL_PROJECTS);
  };

  const renderProjectCard = (project) => {
    return <ProjectCard project={project} />;
  };

  return (
    <div className="projects-container" id={SECTIONS.PROJECTS}>
      <h1 className="projects-title">Projects</h1>
      {PROJECTS.slice(0, 5).map(renderProjectCard)}
      <div className="view-all-projects" onClick={handleOnViewAllProjects}>
        <span className="view-all-projects-text">View All Projects</span>
        <FaArrowRightLong className="view-all-projects-right-icon" />
      </div>
    </div>
  );
}
